<script>
import TableOption from '../../../Components/Tables/TableOption.vue';
import { SIMPLE_DROPDOWN } from '../../../Constants/InputTypes.js';
import {
  NUMBER,
  TOGGLE_SWITCHER,
  SELECT_CSL,
  MULTIPLE_SELECT,
} from '../../../Constants/InputTypes.js';
import { NO_AUTO, SILENT_AUTO } from '../../../Constants/ShopModes.js';
import MultipleSelect from '@/Components/MultipleSelect.vue';

export default {
  components: {
    TableOption,
    MultipleSelect,
  },

  props: {
    masterConfig: Object,
    toggle: Object,
    vehicleIdOptions: Object,
  },

  emits: ['changed'],

  data() {
    return {
      NUMBER,
      SELECT_CSL,
      skipWeekendReminders: this.toggle.skip_weekend_reminders,
      weekDays: {
        Sun: 'Sun',
        Sat: 'Sat',
      },
    };
  },

  computed: {
    serviceWriterPhoneNumber() {
      if (this.masterConfig.mode === NO_AUTO) {
        return 'Use employee Signature and Phone Number?';
      }
      return 'Use Service Writer Signature and Phone Number?';
    },

    serviceWriterPhoneNote() {
      if (this.masterConfig.mode === NO_AUTO) {
        return "Check the box if you want to override your Business Signature and Business Phone Number with a employee's signature and phone number. If the Service Writer has not created their own signature and phone number, it will default to the Business Signature and Business Phone Number.";
      }
      return "Check the box if you want to override your Business Signature and Business Phone Number with a Service Writer's signature and phone number. If the Service Writer has not created their own signature and phone number, it will default to the Business Signature and Business Phone Number.";
    },
    includeApptConfirmation() {
      return this.getToggleValue('include_appt_confirmation');
    },
  },
  methods: {
    getToggleValue(field) {
      return this.toggle?.[field] ? 1 : 0;
    },
    MULTIPLE_SELECT() {
      return MULTIPLE_SELECT;
    },
    NO_AUTO() {
      return NO_AUTO;
    },
    SILENT_AUTO() {
      return SILENT_AUTO;
    },
    TOGGLE_SWITCHER() {
      return TOGGLE_SWITCHER;
    },
    SIMPLE_DROPDOWN() {
      return SIMPLE_DROPDOWN;
    },

    submit(type, field_name, value) {
      this.$emit('changed', {
        type: type,
        field: field_name,
        value: value,
      });
    },
  },
};
</script>

<template>
  <table class="table table-striped">
    <tbody>
      <tr>
        <TableOption
          v-model="masterConfig.dont_send_followup"
          title="Send Follow-up Message?"
          note="Check the box to send each customer a follow-up message."
          @update:model-value="
            (newValue) => submit('master_config', 'dont_send_followup', newValue)
          "
        />
      </tr>

      <tr v-if="masterConfig.mode !== SILENT_AUTO()">
        <TableOption
          v-model="masterConfig.respond_shop_email"
          title="Send Customer's Text Response to Shop's Email"
          note="Check the box to turn on ability for the customer's text response to be sent to the shop's email address(es)."
          @update:model-value="
            (newValue) => submit('master_config', 'respond_shop_email', newValue)
          "
        />
      </tr>

      <tr v-if="masterConfig.mode !== SILENT_AUTO()">
        <TableOption
          v-model="masterConfig.signature_exclude_phonenumber"
          title="Remove Business Phone Number from Text Signature?"
          note="Check the box if you want to remove the Business Phone Number from text followup messages."
          @update:model-value="
            (newValue) => submit('master_config', 'signature_exclude_phonenumber', newValue)
          "
        />
      </tr>

      <tr>
        <TableOption
          v-model="masterConfig.override_signature"
          :title="serviceWriterPhoneNumber"
          :note="serviceWriterPhoneNote"
          @update:model-value="
            (newValue) => submit('master_config', 'override_signature', newValue)
          "
        />
      </tr>

      <tr>
        <TableOption
          v-model="masterConfig.include_firstname"
          title="Include First Name?"
          note="Check the box if you want to include a customer's first name in the message greeting."
          @update:model-value="(newValue) => submit('master_config', 'include_firstname', newValue)"
        />
      </tr>

      <tr v-if="masterConfig.mode !== NO_AUTO()">
        <TableOption
          v-model="masterConfig.include_vehicle_id"
          title="Include Vehicle ID?"
          note="Check the box if you want to include the special vehicle identifier field in the message."
          :type="SIMPLE_DROPDOWN()"
          :options="vehicleIdOptions"
          @update:model-value="
            (newValue) => submit('master_config', 'include_vehicle_id', newValue)
          "
        />
      </tr>

      <tr>
        <TableOption
          v-model="masterConfig.single_notification_queue"
          title="Single Notification Queue"
          note="Check the box if you want to use a single notification queue for Admin and SW accounts."
          @update:model-value="
            (newValue) => submit('master_config', 'single_notification_queue', newValue)
          "
        />
      </tr>

      <tr>
        <TableOption
          v-model="includeApptConfirmation"
          title="Include Appointment Confirmation"
          note="Check the box if you want to include confirmation in the appointment message"
          @update:model-value="
            (newValue) => submit('toggle', 'include_appt_confirmation', newValue)
          "
        />
      </tr>

      <tr>
        <TableOption
          v-model="toggle.mute_appt_notifications"
          title="Hide Appointment Confirmation Notifications"
          note="Check the box to supress the inbound message notifications when a customer replies 'y' to confirm their appointment. Requires the 'Include Appointment Confirmation' toggle be on to use."
          @update:model-value="(newValue) => submit('toggle', 'mute_appt_notifications', newValue)"
        />
      </tr>

      <tr>
        <TableOption
          v-model="toggle.require_2fa"
          title="Require 2FA for all users"
          note="Force all users to login with 2-factor authentication."
          @update:model-value="(newValue) => submit('toggle', 'require_2fa', newValue)"
        />
      </tr>

      <tr>
        <TableOption
          v-model="toggle.customer_score"
          :type="TOGGLE_SWITCHER()"
          title="Enable Customer Score Tracking"
          note="Check the box to enable customer score tracking on a 1-10 scale. Toggle on to allow your staff to make notes and manually set customer sentiment.  Results are internal only and visible on the active customer page as well as client profiles."
          @update:model-value="(newValue) => submit('toggle', 'customer_score', newValue)"
        />
      </tr>

      <tr>
        <TableOption
          v-model="toggle.notifications_retention"
          :type="NUMBER"
          title="Notifications Expiry"
          :max="30"
          :min="1"
          note="Set number of days for expiring notifications"
          @update:model-value="(newValue) => submit('toggle', 'notifications_retention', newValue)"
        />
      </tr>
      <tr>
        <TableOption
          v-model="skipWeekendReminders"
          :type="MULTIPLE_SELECT()"
          title="Skip Weekend Reminders"
          note="Check the box to skip weekend reminders."
          :email="false"
          :options="weekDays"
          @update:model-value="(newValue) => submit('toggle', 'skip_weekend_reminders', newValue)"
        />
      </tr>
    </tbody>
  </table>
</template>
